import * as React from "react";
import { SVGProps, memo } from "react";

const SvgJcbv3 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={44} height={30} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M41.037 29.672H2.677C1.248 29.672 0 28.435 0 27.022V2.65C0 1.236 1.249 0 2.676 0h38.36c1.428 0 2.677 1.236 2.677 2.65v24.373c0 1.412-1.07 2.649-2.676 2.649Z"
      fill="#fff"
    />

    <path
      d="M37 22.196c0 2.544-2.09 4.615-4.658 4.615H7V8.534C7 5.991 9.09 3.92 11.658 3.92H37v18.276Z"
      fill="#fff"
    />

    <path
      d="M28.748 17.509h1.926c.055 0 .183-.018.238-.018a.853.853 0 0 0 .679-.854.883.883 0 0 0-.679-.854c-.055-.018-.165-.018-.238-.018h-1.926v1.744Z"
      fill="url(#JCBv3_svg__a)"
    />

    <path
      d="M30.454 5.464c-1.834 0-3.338 1.472-3.338 3.307v3.433h4.713c.11 0 .238 0 .33.018 1.064.055 1.852.6 1.852 1.545 0 .745-.532 1.38-1.522 1.508v.036c1.082.073 1.907.672 1.907 1.599 0 .999-.917 1.653-2.127 1.653h-5.171v6.722h4.896c1.834 0 3.337-1.471 3.337-3.306V5.463h-4.877Z"
      fill="url(#JCBv3_svg__b)"
    />

    <path
      d="M31.352 13.985a.775.775 0 0 0-.678-.781c-.037 0-.129-.019-.184-.019h-1.742v1.6h1.742c.055 0 .165 0 .184-.02a.775.775 0 0 0 .678-.78Z"
      fill="url(#JCBv3_svg__c)"
    />

    <path
      d="M12.006 5.464c-1.834 0-3.337 1.472-3.337 3.307v8.157c.935.454 1.907.745 2.879.745 1.155 0 1.778-.69 1.778-1.635v-3.852h2.861v3.834c0 1.49-.935 2.707-4.108 2.707-1.925 0-3.429-.418-3.429-.418v6.958h4.896c1.834 0 3.338-1.472 3.338-3.307V5.464h-4.878Z"
      fill="url(#JCBv3_svg__d)"
    />

    <path
      d="M21.23 5.464c-1.834 0-3.338 1.472-3.338 3.307v4.323c.844-.708 2.31-1.162 4.676-1.053 1.266.054 2.623.4 2.623.4v1.398c-.679-.345-1.486-.654-2.53-.726-1.798-.127-2.88.745-2.88 2.27 0 1.545 1.082 2.417 2.88 2.272 1.044-.073 1.851-.4 2.53-.727v1.399s-1.339.345-2.623.4c-2.365.108-3.832-.346-4.676-1.054v7.63h4.896c1.834 0 3.338-1.471 3.338-3.306V5.464H21.23Z"
      fill="url(#JCBv3_svg__e)"
    />

    <defs>
      <linearGradient
        id="JCBv3_svg__a"
        x1={27.113}
        y1={16.639}
        x2={35.354}
        y2={16.639}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgba(0, 121, 64, 1)" />

        <stop offset={0.229} stopColor="rgba(0, 135, 63, 1)" />

        <stop offset={0.743} stopColor="rgba(64, 167, 55, 1)" />

        <stop offset={1} stopColor="rgba(92, 181, 49, 1)" />
      </linearGradient>

      <linearGradient
        id="JCBv3_svg__b"
        x1={27.113}
        y1={15.367}
        x2={35.354}
        y2={15.367}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgba(0, 121, 64, 1)" />

        <stop offset={0.229} stopColor="rgba(0, 135, 63, 1)" />

        <stop offset={0.743} stopColor="rgba(64, 167, 55, 1)" />

        <stop offset={1} stopColor="rgba(92, 181, 49, 1)" />
      </linearGradient>

      <linearGradient
        id="JCBv3_svg__c"
        x1={27.113}
        y1={13.982}
        x2={35.354}
        y2={13.982}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgba(0, 121, 64, 1)" />

        <stop offset={0.229} stopColor="rgba(0, 135, 63, 1)" />

        <stop offset={0.743} stopColor="rgba(64, 167, 55, 1)" />

        <stop offset={1} stopColor="rgba(92, 181, 49, 1)" />
      </linearGradient>

      <linearGradient
        id="JCBv3_svg__d"
        x1={8.665}
        y1={15.367}
        x2={17.033}
        y2={15.367}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgba(31, 40, 111, 1)" />

        <stop offset={0.475} stopColor="rgba(0, 78, 148, 1)" />

        <stop offset={0.826} stopColor="rgba(0, 102, 177, 1)" />

        <stop offset={1} stopColor="rgba(0, 111, 188, 1)" />
      </linearGradient>

      <linearGradient
        id="JCBv3_svg__e"
        x1={17.845}
        y1={15.367}
        x2={25.972}
        y2={15.367}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="rgba(108, 44, 47, 1)" />

        <stop offset={0.173} stopColor="rgba(136, 39, 48, 1)" />

        <stop offset={0.573} stopColor="rgba(190, 24, 51, 1)" />

        <stop offset={0.859} stopColor="rgba(190, 24, 51, 1)" />

        <stop offset={1} stopColor="rgba(230, 0, 57, 1)" />
      </linearGradient>
    </defs>
  </svg>
);

const Memo = memo(SvgJcbv3);

export default Memo;
